// extracted by mini-css-extract-plugin
export default {"title":"NSBarTitle_title__9Iyd-","description":"NSBarTitle_description__sjo9p"};